import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GridRefreshService {

  constructor() { }

  private _listners = new Subject<any>();

  listen(): Observable<any> {
    return this._listners.asObservable();
  }

  refreshGrid(filterBy: any) {
    this._listners.next(filterBy)
  }

}
